export default __webpack_public_path__ + "static/media/logo-text.d1b675cb.svg";